import React, { createContext, useState, useEffect } from "react";
import CategoriesData from "../data.js";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [apiData, setApiData] = useState([]);
  const [inputAmount, setInputAmount] = useState("");
  const [wizardCategories, setWizardCategories] = useState(
    JSON.parse(localStorage.getItem("categories")) || CategoriesData || []
  );
  const [checkedCategory, setCheckedCategory] = useState(
    new Array(CategoriesData.length).fill(false)
  );

  const [entries, setEntries] = useState(
    JSON.parse(localStorage.getItem("entries")) || []
  );
  console.log("entries context", entries);
  const [openFabModal, setOpenFabModal] = useState(false);
  const [openEntryModal, setOpenEntryModal] = useState(false);
  const [editingEntry, setEditingEntry] = useState(false);
  const [addNewItem, setAddNewItem] = useState({
    id: new Date().valueOf(),
    type: "Income",
    category: "",
    amount: "",
    date: new Date(),
    desc: "",
  });

  const [contextMenu, setContextMenu] = useState(null);

  const [income, setIncome] = useState([]);

  const [expense, setExpense] = useState([]);

  console.log("income", income);

  useEffect(() => {
    fetch("https://randomuser.me/api/")
      .then((rez) => rez.json())
      .then((data) => setApiData(data));
  }, []);

  // Sum of Entries
  useEffect(() => {
    handleExpenseIncomeSum();
  }, [entries]);

  const handleExpenseIncomeSum = () => {
    console.log("entries on load", entries);
    setIncome(reduceEntries("Income"));
    setExpense(reduceEntries("Expense"));
  };

  const reduceEntries = (type) => {
    return Array.from(
      entries
        .filter((e) => e.category.type === type)
        .reduce(
          (m, { category, amount }) =>
            m.set(category.id, (m.get(category.id) || 0) + parseFloat(amount)),
          new Map()
        )
        .entries(),
      ([id, amount]) => ({ id, amount })
    );
  };

  const value = {
    apiData,
    inputAmount,
    setInputAmount,
    wizardCategories,
    setWizardCategories,
    checkedCategory,
    setCheckedCategory,
    entries,
    setEntries,
    openFabModal,
    setOpenFabModal,
    openEntryModal,
    setOpenEntryModal,
    editingEntry,
    setEditingEntry,
    addNewItem,
    setAddNewItem,
    contextMenu,
    setContextMenu,
    income,
    setIncome,
    expense,
    setExpense,
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
